var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { plainToInstance, Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { PatientDataVisualizationLiteDto, PatientDataVisualizationPdfStatus } from "./patient.data.visualization.dtos";
import { ContactMethod } from "./consentconfig.dtos";
import { DocumentDeliveryDto } from "./document.delivery.dtos";
import { OmitType } from "@nestjs/mapped-types";
export var DocumentVectorizationStatus;
(function (DocumentVectorizationStatus) {
    DocumentVectorizationStatus["NOT_STARTED"] = "NOT_STARTED";
    DocumentVectorizationStatus["PENDING"] = "PENDING";
    DocumentVectorizationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DocumentVectorizationStatus["COMPLETE"] = "COMPLETE";
    DocumentVectorizationStatus["FAILED"] = "FAILED";
})(DocumentVectorizationStatus || (DocumentVectorizationStatus = {}));
export var DocumentRetrievalOrigin;
(function (DocumentRetrievalOrigin) {
    DocumentRetrievalOrigin["PATIENT"] = "PATIENT";
    DocumentRetrievalOrigin["ORGANIZATION"] = "ORGANIZATION";
    DocumentRetrievalOrigin["MCP"] = "MCP";
    DocumentRetrievalOrigin["BACKGROUND_REFRESH"] = "BACKGROUND_REFRESH";
    DocumentRetrievalOrigin["TESTING"] = "TESTING";
    DocumentRetrievalOrigin["UNKNOWN"] = "UNKNOWN";
})(DocumentRetrievalOrigin || (DocumentRetrievalOrigin = {}));
export var EpicIntegration;
(function (EpicIntegration) {
    EpicIntegration["OPEN_EPIC"] = "OPEN_EPIC";
    EpicIntegration["EPIC_NEXUS"] = "EPIC_NEXUS";
})(EpicIntegration || (EpicIntegration = {}));
export var DocumentRetrievalFailureReason;
(function (DocumentRetrievalFailureReason) {
    DocumentRetrievalFailureReason["INVALID_IAL2_TOKEN"] = "DOCUMENT_RETRIEVAL_INVALID_IAL2_TOKEN";
    DocumentRetrievalFailureReason["MED_ALLIES_ADD_PATIENT"] = "DOCUMENT_RETRIEVAL_MED_ALLIES_ADD_PATIENT_ERROR";
    DocumentRetrievalFailureReason["MED_ALLIES_GET_DOCUMENTS"] = "DOCUMENT_RETRIEVAL_MED_ALLIES_GET_DOCUMENTS_ERROR";
    DocumentRetrievalFailureReason["MED_ALLIES_GET_ENDPOINTS"] = "DOCUMENT_RETRIEVAL_MED_ALLIES_GET_ENDPOINTS_ERROR";
    DocumentRetrievalFailureReason["COMMONWELL_ADD_PATIENT"] = "DOCUMENT_RETRIEVAL_COMMONWELL_ADD_PATIENT_ERROR";
    DocumentRetrievalFailureReason["COMMONWELL_GET_DOCUMENTS"] = "DOCUMENT_RETRIEVAL_COMMONWELL_GET_DOCUMENTS_ERROR";
    DocumentRetrievalFailureReason["TIMEOUT"] = "DOCUMENT_RETRIEVAL_TIMEOUT";
    DocumentRetrievalFailureReason["GENERIC_ERROR"] = "DOCUMENT_RETRIEVAL_GENERIC_ERROR";
    DocumentRetrievalFailureReason["SKIPPED_TEFCA_CALLS"] = "DOCUMENT_RETRIEVAL_SKIPPED_TEFCA_CALLS";
    DocumentRetrievalFailureReason["MAX_RETRIES_REACHED"] = "DOCUMENT_RETRIEVAL_MAX_RETRIES_REACHED";
    DocumentRetrievalFailureReason["CLEAR_VALIDATION_FAILED"] = "DOCUMENT_RETRIEVAL_CLEAR_VALIDATION_FAILED";
})(DocumentRetrievalFailureReason || (DocumentRetrievalFailureReason = {}));
export class DocumentRetrievalTaskBatchInput {
}
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskBatchInput.prototype, "batchId", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentRetrievalTaskBatchInput.prototype, "documentSelectionComplete", void 0);
export class PatientInitiatedRetrieveDataInput {
}
__decorate([
    IsString(),
    IsOptional()
], PatientInitiatedRetrieveDataInput.prototype, "studyId", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientInitiatedRetrieveDataInput.prototype, "useTefca", void 0);
export var DataRetrievalFailureReason;
(function (DataRetrievalFailureReason) {
    DataRetrievalFailureReason["GENERIC_ERROR"] = "GENERIC_ERROR";
    DataRetrievalFailureReason["PATIENT_NOT_FOUND"] = "PATIENT_NOT_FOUND";
})(DataRetrievalFailureReason || (DataRetrievalFailureReason = {}));
export var DataUpdateFailurePatientActionNeededReason;
(function (DataUpdateFailurePatientActionNeededReason) {
    DataUpdateFailurePatientActionNeededReason["UNLOCKED_OR_NO_TARGETED_LIST"] = "UNLOCKED_OR_NO_TARGETED_LIST";
    DataUpdateFailurePatientActionNeededReason["MISSING_REFRESH_TOKENS"] = "MISSING_REFRESH_TOKENS";
    DataUpdateFailurePatientActionNeededReason["NEW_FACILITY_AUTHENTICATION_NEEDED"] = "NEW_FACILITY_AUTHENTICATION_NEEDED";
    DataUpdateFailurePatientActionNeededReason["UNABLE_TO_REFRESH_TOKENS"] = "UNABLE_TO_REFRESH_TOKENS";
    DataUpdateFailurePatientActionNeededReason["CONSENT_NOT_FOUND"] = "CONSENT_NOT_FOUND";
    DataUpdateFailurePatientActionNeededReason["CONSENT_EXPIRED"] = "CONSENT_EXPIRED";
    DataUpdateFailurePatientActionNeededReason["CONSENT_REVOKED"] = "CONSENT_REVOKED";
    DataUpdateFailurePatientActionNeededReason["NO_PREVIOUS_BATCH"] = "NO_PREVIOUS_BATCH";
})(DataUpdateFailurePatientActionNeededReason || (DataUpdateFailurePatientActionNeededReason = {}));
export class UpdateDocumentRetrievalTaskBatchInput {
}
__decorate([
    IsBoolean(),
    IsOptional()
], UpdateDocumentRetrievalTaskBatchInput.prototype, "documentSelectionComplete", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdateDocumentRetrievalTaskBatchInput.prototype, "skipLocationId", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional()
], UpdateDocumentRetrievalTaskBatchInput.prototype, "excludedLocationIds", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], UpdateDocumentRetrievalTaskBatchInput.prototype, "patientHasDownloaded", void 0);
__decorate([
    IsEnum(DocumentVectorizationStatus),
    IsOptional()
], UpdateDocumentRetrievalTaskBatchInput.prototype, "documentVectorizationStatus", void 0);
export var DocumentRetrievalTaskSource;
(function (DocumentRetrievalTaskSource) {
    DocumentRetrievalTaskSource["MEDALLIES"] = "MEDALLIES";
    DocumentRetrievalTaskSource["COMMONWELL"] = "COMMONWELL";
    DocumentRetrievalTaskSource["FFHIR"] = "FFHIR";
    DocumentRetrievalTaskSource["PARTICLE_EPIC"] = "PARTICLE_EPIC";
    DocumentRetrievalTaskSource["PARTICLE_FASTEN"] = "PARTICLE_FASTEN";
    DocumentRetrievalTaskSource["HEALTHEX_EPIC"] = "HEALTHEX_EPIC";
    DocumentRetrievalTaskSource["FASTEN"] = "FASTEN";
    DocumentRetrievalTaskSource["HX_TEST"] = "HX_TEST";
})(DocumentRetrievalTaskSource || (DocumentRetrievalTaskSource = {}));
export class DocumentRetrievalTEFCAInput {
}
__decorate([
    IsString()
], DocumentRetrievalTEFCAInput.prototype, "ial2IdToken", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTEFCAInput.prototype, "ial2RefreshToken", void 0);
export class DocumentRetrievalTaskFastenInput {
}
__decorate([
    IsString()
], DocumentRetrievalTaskFastenInput.prototype, "connectionId", void 0);
__decorate([
    IsString()
], DocumentRetrievalTaskFastenInput.prototype, "portalId", void 0);
__decorate([
    IsString()
], DocumentRetrievalTaskFastenInput.prototype, "brandId", void 0);
__decorate([
    IsString()
], DocumentRetrievalTaskFastenInput.prototype, "endpointId", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskSource),
    IsOptional()
], DocumentRetrievalTaskFastenInput.prototype, "source", void 0);
export class DocumentRetrievalTaskFacilitatedFHIRInput {
}
__decorate([
    IsString()
], DocumentRetrievalTaskFacilitatedFHIRInput.prototype, "documentId", void 0);
__decorate([
    IsString()
], DocumentRetrievalTaskFacilitatedFHIRInput.prototype, "accessToken", void 0);
export var DocumentRetrievalLocationStatus;
(function (DocumentRetrievalLocationStatus) {
    DocumentRetrievalLocationStatus["NEEDS_AUTH"] = "NEEDS_AUTH";
    DocumentRetrievalLocationStatus["SKIPPED"] = "SKIPPED";
    DocumentRetrievalLocationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DocumentRetrievalLocationStatus["COMPLETE"] = "COMPLETE";
    DocumentRetrievalLocationStatus["ERROR"] = "ERROR";
})(DocumentRetrievalLocationStatus || (DocumentRetrievalLocationStatus = {}));
export var DocumentRetrievalTaskStatus;
(function (DocumentRetrievalTaskStatus) {
    DocumentRetrievalTaskStatus["RETRIEVING"] = "RETRIEVING";
    DocumentRetrievalTaskStatus["COMPLETE"] = "COMPLETE";
    DocumentRetrievalTaskStatus["ERROR"] = "ERROR";
})(DocumentRetrievalTaskStatus || (DocumentRetrievalTaskStatus = {}));
export var DocumentRetrievalAuthType;
(function (DocumentRetrievalAuthType) {
    DocumentRetrievalAuthType["IAS"] = "IAS";
    DocumentRetrievalAuthType["FASTEN"] = "FASTEN";
    DocumentRetrievalAuthType["FACILITATED_FHIR_EPIC"] = "FACILITATED_FHIR_EPIC";
    DocumentRetrievalAuthType["FACILITATED_FHIR_OTHER"] = "FACILITATED_FHIR_OTHER";
})(DocumentRetrievalAuthType || (DocumentRetrievalAuthType = {}));
export var DocumentRetrievalTaskSourceType;
(function (DocumentRetrievalTaskSourceType) {
    DocumentRetrievalTaskSourceType["DOCUMENTS"] = "DOCUMENTS";
    DocumentRetrievalTaskSourceType["ENDPOINTS"] = "ENDPOINTS";
})(DocumentRetrievalTaskSourceType || (DocumentRetrievalTaskSourceType = {}));
export class DocumentRetrievalLocationMetadataBaseDto {
}
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], DocumentRetrievalLocationMetadataBaseDto.prototype, "authType", void 0);
export class DocumentRetrievalLocationMetadataIASDto {
    constructor() {
        this.authType = DocumentRetrievalAuthType.IAS;
    }
}
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], DocumentRetrievalLocationMetadataIASDto.prototype, "authType", void 0);
export class DocumentRetrievalLocationMetadataFastenDto extends DocumentRetrievalLocationMetadataBaseDto {
    constructor() {
        super(...arguments);
        this.authType = DocumentRetrievalAuthType.FASTEN;
        this.organizationConnectionId = null;
    }
}
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], DocumentRetrievalLocationMetadataFastenDto.prototype, "authType", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalLocationMetadataFastenDto.prototype, "organizationConnectionId", void 0);
__decorate([
    IsString()
], DocumentRetrievalLocationMetadataFastenDto.prototype, "portalId", void 0);
__decorate([
    IsString()
], DocumentRetrievalLocationMetadataFastenDto.prototype, "brandId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalLocationMetadataFastenDto.prototype, "endpointId", void 0);
export class DocumentRetrievalLocationMetadataFhirEpicDto {
    constructor() {
        this.authType = DocumentRetrievalAuthType.FACILITATED_FHIR_EPIC;
    }
}
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], DocumentRetrievalLocationMetadataFhirEpicDto.prototype, "authType", void 0);
__decorate([
    IsString()
], DocumentRetrievalLocationMetadataFhirEpicDto.prototype, "fhirEndpoint", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentRetrievalLocationMetadataFhirEpicDto.prototype, "myChartCentral", void 0);
__decorate([
    IsEnum(EpicIntegration),
    IsOptional()
], DocumentRetrievalLocationMetadataFhirEpicDto.prototype, "epicIntegration", void 0);
export class DocumentRetrievalLocationMetadataFhirOtherDto {
    constructor() {
        this.authType = DocumentRetrievalAuthType.FACILITATED_FHIR_OTHER;
    }
}
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], DocumentRetrievalLocationMetadataFhirOtherDto.prototype, "authType", void 0);
export function documentRetrievalLocationMetadataFromString(metadata) {
    if (!metadata)
        return null;
    try {
        const json = JSON.parse(metadata);
        switch (json.authType) {
            case DocumentRetrievalAuthType.IAS:
                return plainToInstance(DocumentRetrievalLocationMetadataIASDto, json);
            case DocumentRetrievalAuthType.FASTEN:
                return plainToInstance(DocumentRetrievalLocationMetadataFastenDto, json);
            case DocumentRetrievalAuthType.FACILITATED_FHIR_EPIC:
                return plainToInstance(DocumentRetrievalLocationMetadataFhirEpicDto, json);
            case DocumentRetrievalAuthType.FACILITATED_FHIR_OTHER:
                return plainToInstance(DocumentRetrievalLocationMetadataFhirOtherDto, json);
            default:
                return null;
        }
    }
    catch (error) {
        console.error(`Error parsing document retrieval location metadata ${JSON.stringify(metadata)} ${JSON.stringify(error)} `);
        return null;
    }
}
export function documentRetrievalLocationMetadataIASFromString(metadata) {
    if (!metadata)
        return null;
    const json = JSON.parse(metadata);
    return plainToInstance(DocumentRetrievalLocationMetadataIASDto, json);
}
export class DocumentRetrievalLocationDto {
}
__decorate([
    IsString()
], DocumentRetrievalLocationDto.prototype, "id", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskSource)
], DocumentRetrievalLocationDto.prototype, "source", void 0);
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], DocumentRetrievalLocationDto.prototype, "authType", void 0);
__decorate([
    IsEnum(DocumentRetrievalLocationStatus)
], DocumentRetrievalLocationDto.prototype, "status", void 0);
__decorate([
    IsString()
], DocumentRetrievalLocationDto.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalLocationDto.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalLocationDto.prototype, "organizationLogoUrl", void 0);
__decorate([
    Type(() => Object, {
        discriminator: {
            property: "authType",
            subTypes: [
                { value: DocumentRetrievalLocationMetadataIASDto, name: DocumentRetrievalAuthType.IAS },
                { value: DocumentRetrievalLocationMetadataFastenDto, name: DocumentRetrievalAuthType.FASTEN },
                { value: DocumentRetrievalLocationMetadataFhirEpicDto, name: DocumentRetrievalAuthType.FACILITATED_FHIR_EPIC },
                { value: DocumentRetrievalLocationMetadataFhirOtherDto, name: DocumentRetrievalAuthType.FACILITATED_FHIR_OTHER },
            ],
        },
    }),
    ValidateNested(),
    IsOptional()
], DocumentRetrievalLocationDto.prototype, "organizationMetadata", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentRetrievalLocationDto.prototype, "isExcluded", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], DocumentRetrievalLocationDto.prototype, "updatedAt", void 0);
__decorate([
    IsBoolean()
], DocumentRetrievalLocationDto.prototype, "isPrevious", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalLocationDto.prototype, "hcid", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalLocationDto.prototype, "hash", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalLocationDto.prototype, "fastenTaskId", void 0);
export class CreateOrUpdateDocumentRetrievalLocationInput extends OmitType(DocumentRetrievalLocationDto, ["isPrevious", "hash"]) {
}
export var DocumentContentType;
(function (DocumentContentType) {
    DocumentContentType["FHIR"] = "fhir";
    DocumentContentType["CCDA"] = "ccda";
    DocumentContentType["OTHER"] = "other";
})(DocumentContentType || (DocumentContentType = {}));
export class DocumentRetrievalTecfaTaskRetrievalMetadataDto {
}
__decorate([
    IsString()
], DocumentRetrievalTecfaTaskRetrievalMetadataDto.prototype, "magDI", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTecfaTaskRetrievalMetadataDto.prototype, "contentType", void 0);
__decorate([
    IsEnum(DocumentContentType)
], DocumentRetrievalTecfaTaskRetrievalMetadataDto.prototype, "documentType", void 0);
export class DocumentRetrievalTaskDto {
}
__decorate([
    IsString()
], DocumentRetrievalTaskDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString()
], DocumentRetrievalTaskDto.prototype, "filename", void 0);
__decorate([
    IsString()
], DocumentRetrievalTaskDto.prototype, "locationId", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskSource)
], DocumentRetrievalTaskDto.prototype, "source", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskStatus)
], DocumentRetrievalTaskDto.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskDto.prototype, "retrievalMetadata", void 0);
__decorate([
    IsBoolean()
], DocumentRetrievalTaskDto.prototype, "isPrevious", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskDto.prototype, "hash", void 0);
export class CreateOrUpdateDocumentRetrievalTaskInput extends OmitType(DocumentRetrievalTaskDto, ["isPrevious", "hash"]) {
}
export class DocumentRetrievalTEFCADto {
}
__decorate([
    IsEnum(DocumentRetrievalTaskSource)
], DocumentRetrievalTEFCADto.prototype, "source", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskSourceType)
], DocumentRetrievalTEFCADto.prototype, "sourceType", void 0);
__decorate([
    IsBoolean()
], DocumentRetrievalTEFCADto.prototype, "isComplete", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTEFCADto.prototype, "error", void 0);
__decorate([
    Type(() => DocumentRetrievalLocationMetadataIASDto),
    IsOptional()
], DocumentRetrievalTEFCADto.prototype, "metadata", void 0);
export class DocumentRetrievalTaskBatchDto {
}
__decorate([
    IsString()
], DocumentRetrievalTaskBatchDto.prototype, "batchId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "previousBatchId", void 0);
__decorate([
    IsString()
], DocumentRetrievalTaskBatchDto.prototype, "patientId", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], DocumentRetrievalTaskBatchDto.prototype, "createdAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "isDataUpdate", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "allowOnlyTargetedFacilities", void 0);
__decorate([
    IsArray(),
    Type(() => DocumentRetrievalTEFCADto),
    ValidateNested({ each: true })
], DocumentRetrievalTaskBatchDto.prototype, "tefcaQueries", void 0);
__decorate([
    IsArray(),
    Type(() => DocumentRetrievalLocationDto),
    ValidateNested({ each: true })
], DocumentRetrievalTaskBatchDto.prototype, "locations", void 0);
__decorate([
    IsArray(),
    Type(() => DocumentRetrievalTaskDto),
    ValidateNested({ each: true })
], DocumentRetrievalTaskBatchDto.prototype, "documents", void 0);
__decorate([
    IsArray(),
    Type(() => DocumentDeliveryDto),
    ValidateNested({ each: true })
], DocumentRetrievalTaskBatchDto.prototype, "documentDeliveries", void 0);
__decorate([
    IsBoolean()
], DocumentRetrievalTaskBatchDto.prototype, "documentSelectionComplete", void 0);
__decorate([
    IsBoolean()
], DocumentRetrievalTaskBatchDto.prototype, "finalized", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date)
], DocumentRetrievalTaskBatchDto.prototype, "finalizedAt", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date)
], DocumentRetrievalTaskBatchDto.prototype, "lastBackgroundRefreshAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "isAIFlow", void 0);
__decorate([
    IsEnum(DocumentVectorizationStatus),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "documentVectorizationStatus", void 0);
__decorate([
    IsBoolean()
], DocumentRetrievalTaskBatchDto.prototype, "patientHasDownloaded", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date)
], DocumentRetrievalTaskBatchDto.prototype, "patientDeliveryExpiration", void 0);
__decorate([
    IsEnum(PatientDataVisualizationPdfStatus),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "pdfStatus", void 0);
__decorate([
    Type(() => PatientDataVisualizationLiteDto),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "patientData", void 0);
__decorate([
    IsEnum(ContactMethod),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "patientContactMethod", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "hash", void 0);
__decorate([
    IsEnum(DocumentVectorizationStatus),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationStatus", void 0);
__decorate([
    IsEnum(DocumentVectorizationStatus),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationIngestionStatus", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationKnowledgeBaseId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationVectorIndexName", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDataSourceId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationIngestionJobId", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationUpdatedAt", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsScanned", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsIndexed", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsModified", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsDeleted", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsFailed", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationIngestionFailureReasons", void 0);
__decorate([
    IsEnum(DocumentRetrievalOrigin)
], DocumentRetrievalTaskBatchDto.prototype, "origin", void 0);
export class DocumentRetrievalTaskDownloadDto {
}
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskDownloadDto.prototype, "errorMessage", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentRetrievalTaskDownloadDto.prototype, "downloadLink", void 0);
export class AWSDataDeliveryInfoDto {
}
__decorate([
    IsString()
], AWSDataDeliveryInfoDto.prototype, "externalDataDeliveryRoleARN", void 0);
export class AuthorizeUrlInput {
}
__decorate([
    IsString()
], AuthorizeUrlInput.prototype, "fhirEndpoint", void 0);
__decorate([
    IsString()
], AuthorizeUrlInput.prototype, "redirectUrl", void 0);
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], AuthorizeUrlInput.prototype, "authType", void 0);
__decorate([
    IsEnum(EpicIntegration)
], AuthorizeUrlInput.prototype, "epicIntegration", void 0);
export class AuthorizeUrlDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], AuthorizeUrlDto.prototype, "url", void 0);
__decorate([
    IsString()
], AuthorizeUrlDto.prototype, "state", void 0);
export class GetFHIRRecordsInput {
}
__decorate([
    IsString()
], GetFHIRRecordsInput.prototype, "locationId", void 0);
__decorate([
    IsString()
], GetFHIRRecordsInput.prototype, "fhirEndpoint", void 0);
__decorate([
    IsString()
], GetFHIRRecordsInput.prototype, "redirectUri", void 0);
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], GetFHIRRecordsInput.prototype, "authType", void 0);
__decorate([
    IsString()
], GetFHIRRecordsInput.prototype, "code", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], GetFHIRRecordsInput.prototype, "createFromEpicDirectory", void 0);
__decorate([
    IsEnum(EpicIntegration)
], GetFHIRRecordsInput.prototype, "epicIntegration", void 0);
export class PatientTEFCAAuthInfoDto {
}
__decorate([
    IsBoolean()
], PatientTEFCAAuthInfoDto.prototype, "ial2Authorized", void 0);
__decorate([
    IsBoolean()
], PatientTEFCAAuthInfoDto.prototype, "ial2Expired", void 0);
export class SuggestedFastenEndpointDto {
}
__decorate([
    IsString()
], SuggestedFastenEndpointDto.prototype, "brandId", void 0);
__decorate([
    IsString()
], SuggestedFastenEndpointDto.prototype, "brandName", void 0);
__decorate([
    IsString(),
    IsOptional()
], SuggestedFastenEndpointDto.prototype, "brandLogo", void 0);
__decorate([
    IsString(),
    IsOptional()
], SuggestedFastenEndpointDto.prototype, "brandState", void 0);
__decorate([
    IsString()
], SuggestedFastenEndpointDto.prototype, "portalId", void 0);
__decorate([
    IsString(),
    IsOptional()
], SuggestedFastenEndpointDto.prototype, "portalName", void 0);
__decorate([
    IsString()
], SuggestedFastenEndpointDto.prototype, "endpointId", void 0);
__decorate([
    IsString(),
    IsOptional()
], SuggestedFastenEndpointDto.prototype, "endpointPlatformType", void 0);
__decorate([
    IsString(),
    IsOptional()
], SuggestedFastenEndpointDto.prototype, "endpointUrl", void 0);
__decorate([
    IsString()
], SuggestedFastenEndpointDto.prototype, "matchedBy", void 0);
